module.exports = __webpack_public_path__ + "static/media/FazzNeue-Light.3025015d.ttf";